module.exports = __webpack_public_path__ + "static/media/trash2.b0c30787.svg";